(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["metropolis-gallery"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('metropolis-gallery')){customElements.define('metropolis-gallery',class extends HTMLElement{connectedCallback(){this.onGalleryClick=(event)=>{const button=event.target.closest('button[data-direction]');if(!button)return;const track=this.querySelector('.metropolis-gallery__track');const card=track.querySelector('figure');if(card)track.scrollBy({left:(card.getBoundingClientRect().width+16)*Number(button.dataset.direction),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});};this.addEventListener('click',this.onGalleryClick);}disconnectedCallback(){this.removeEventListener('click',this.onGalleryClick);}});}

  } catch(e) { console.error(e); }
})();
})();
